module.exports = __webpack_public_path__ + "public/956478008fffbb571f4216904a65bb0f.ttf";